import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withKeys as _withKeys, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  style: {"background":"transparent"},
  class: "d-flex flex-d-c max-width p-relative input-simple-container"
}
const _hoisted_2 = {
  key: 1,
  class: "coral-grey3-color fs-small pt-1 pl-1"
}
const _hoisted_3 = {
  key: 0,
  class: "coral-grey3-color fs-small pt-1 pl-1",
  style: {"min-height":"calc(15px + .5em)"}
}

import { IonInput } from "@ionic/vue";
import { computed, onMounted } from "vue";
import { useField } from "vee-validate";

import { AUTO_CAPITALIZE_MODE, AUTO_COMPLETE_FIELD, INPUT_TYPE } from "@/types/enum/ionicEnum";
import { BaseInputProps } from "@/types/props";
import { BaseInputEmits } from "@/types/emits";

//TODO: Implement a way to only give a value with the prop "value"

export default /*@__PURE__*/_defineComponent({
  __name: 'InputSimple',
  props: {
    accept: {},
    autocapitalize: { default: AUTO_CAPITALIZE_MODE.OFF },
    autocomplete: { default: AUTO_COMPLETE_FIELD.OFF },
    autocorrect: { default: 'off' },
    autofocus: { type: Boolean, default: false },
    clearInput: { type: Boolean, default: false },
    clearOnEdit: { type: Boolean },
    color: {},
    debounce: { default: 0 },
    disabled: { type: Boolean },
    enterkeyhint: {},
    inputmode: {},
    labelWidth: { default: 'auto' },
    ignoreMaxWidth: { type: Boolean },
    max: {},
    maxlength: {},
    min: {},
    minlength: {},
    mode: {},
    modelValue: {},
    multiple: { type: Boolean },
    name: {},
    pattern: {},
    placeholder: {},
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    size: {},
    spellcheck: { type: Boolean, default: false },
    step: {},
    type: { default: INPUT_TYPE.TEXT },
    validateOption: {},
    inputClass: {}
  },
  emits: ["submit", "change", "update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

// Vee-Validate Composable
const {
    name,
    errors,
    handleBlur,
    validate,
} = useField(
    props.validateOption?.name ?? '',
    props.validateOption?.rules ?? '',
    {
        syncVModel: true,
        valueProp: props.modelValue,
        type: props.type,
        initialValue: JSON.parse(JSON.stringify(props.modelValue ?? '')),
        label: props.validateOption?.label ?? props.validateOption?.name,
        ...props.validateOption?.options ?? {}
    }
)

const inputModelValue = computed<string | number | undefined>({
    get: () => {
        return props.modelValue
    },
    set: (value) => {
        emit('update:modelValue', value);
    }
})

window.addEventListener('change-language', () => validate({ mode: 'force' }))

onMounted(() => {
    const root: HTMLElement | null = document.querySelector(':root')
    root?.style.setProperty('--input-label-width-input-custom', props.labelWidth)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonInput), {
      class: _normalizeClass(["input-simple light-grey4-background purple-purple-color", __props.inputClass]),
      modelValue: inputModelValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputModelValue).value = $event)),
      accept: props.accept,
      autocapitalize: props.autocapitalize,
      autocomplete: props.autocomplete,
      autocorrect: props.autocorrect,
      autofocus: props.autofocus,
      clearOnEdit: props.clearOnEdit,
      color: props.color,
      debounce: props.debounce,
      disabled: props.disabled,
      enterkeyhint: props.enterkeyhint,
      inputmode: props.inputmode,
      max: props.max,
      maxlength: props.maxlength,
      min: props.min,
      minlength: props.minlength,
      mode: props.mode,
      multiple: props.multiple,
      pattern: props.pattern,
      placeholder: props.placeholder,
      readonly: props.readonly,
      required: props.required,
      size: props.size,
      spellcheck: props.spellcheck,
      step: props.step,
      type: props.type,
      name: _unref(name),
      onBlur: _unref(handleBlur),
      onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('submit')), ["enter"])),
      onIonChange: _cache[2] || (_cache[2] = ($event: any) => (emit('change', inputModelValue.value)))
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "modelValue", "accept", "autocapitalize", "autocomplete", "autocorrect", "autofocus", "clearOnEdit", "color", "debounce", "disabled", "enterkeyhint", "inputmode", "max", "maxlength", "min", "minlength", "mode", "multiple", "pattern", "placeholder", "readonly", "required", "size", "spellcheck", "step", "type", "name", "onBlur"]),
    (_ctx.$slots['icon'])
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["p-absolute input-icon-container", {'error-input-icon-container': _unref(errors).length}])
        }, [
          _renderSlot(_ctx.$slots, "icon")
        ], 2))
      : _createCommentVNode("", true),
    (_unref(errors).length || _ctx.$slots['error-message'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "error-message", {}, () => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors), (error) => {
              return (_openBlock(), _createElementBlock("span", { key: error }, _toDisplayString(error), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "custom-helper", {}, () => [
      (_ctx.$slots['helper'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "helper")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})